import { render, staticRenderFns } from "./__store_shelf_batch.vue?vue&type=template&id=13360e36&scoped=true&"
import script from "./__store_shelf_batch.vue?vue&type=script&lang=js&"
export * from "./__store_shelf_batch.vue?vue&type=script&lang=js&"
import style0 from "./__store_shelf_batch.vue?vue&type=style&index=0&id=13360e36&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13360e36",
  null
  
)

export default component.exports